import React from "react";
import { getValue } from "@utils/lodash";

function InfoSvgComponent(props: any) {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg"  width="18" height="18" viewBox="0 0 18 18">
        <defs>
          <clipPath id="clip-path-info">
            <rect id="Rectangle_18416" data-name="Rectangle 18416" width="18" height="18" transform="translate(-18042 -706)" fill="#fff" stroke="#707070" stroke-width="1"/>
          </clipPath>
        </defs>
        <g id="Mask_Group_424" data-name="Mask Group 424" transform="translate(18042 706)" clip-path="url(#clip-path-info)">
          <path id="info_FILL1_wght300_GRAD0_opsz24" d="M9.276-9.118h1.184v-4.539H9.276v4.539Zm.592-5.891a.617.617,0,0,0,.454-.183.617.617,0,0,0,.183-.454.617.617,0,0,0-.183-.454.617.617,0,0,0-.454-.183.617.617,0,0,0-.454.183.617.617,0,0,0-.183.454.617.617,0,0,0,.183.454A.617.617,0,0,0,9.868-15.009Zm0,9.641a7.306,7.306,0,0,1-2.925-.591,7.576,7.576,0,0,1-2.382-1.6,7.572,7.572,0,0,1-1.6-2.381,7.3,7.3,0,0,1-.591-2.924,7.306,7.306,0,0,1,.591-2.925,7.576,7.576,0,0,1,1.6-2.382,7.572,7.572,0,0,1,2.381-1.6,7.3,7.3,0,0,1,2.924-.591,7.306,7.306,0,0,1,2.925.591,7.576,7.576,0,0,1,2.382,1.6,7.572,7.572,0,0,1,1.6,2.381,7.3,7.3,0,0,1,.591,2.924,7.306,7.306,0,0,1-.591,2.925,7.576,7.576,0,0,1-1.6,2.382,7.572,7.572,0,0,1-2.381,1.6,7.3,7.3,0,0,1-2.924.591Z" transform="translate(-18042.369 -683.632)" fill="#dadce0"/>
        </g>
      </svg>
    </>
  );
}

export default InfoSvgComponent;
